import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { observer } from 'mobx-react-lite';
import { isFeatureEnabled } from 'owa-feature-flags';
import loc from 'owa-localize';
import { CancelText } from 'owa-locstrings/lib/strings/canceltext.locstring.json';
import * as React from 'react';
import type FilePickerAction from '../store/schema/FilePickerAction';
import type { AttachOrSharePreference } from '../store/schema/FilePickerUserConfiguration';
import { AttachText, NextText } from './FilePickerPaneBottomPart.locstring.json';
import { FilePickerShareLinkAttachButton } from './FilePickerShareLinkAttachButton';

import styles from './FilePickerPaneBottomPart.scss';

export interface FilePickerPaneBottomPartProps {
    supportedActions: FilePickerAction[];
    onNextClicked: () => void;
    onCancelClicked: () => void;
    onInsertClicked: () => void;
    onAttachClicked: () => void;
    supportsInsertLink: boolean;
    shouldHideInsertButton: boolean;
    disabledAttachTooltip: string;
    attachOrSharePreference?: AttachOrSharePreference;
}

const FilePickerPaneBottomPart = observer(function FilePickerPaneBottomPart(
    props: FilePickerPaneBottomPartProps
) {
    const isSupportedActionsEmpty = !props.supportedActions || props.supportedActions.length == 0;
    const isSplitButtonEnabled: boolean =
        (isFeatureEnabled('doc-deprecateCloudy-preview') ||
            isFeatureEnabled('doc-deprecateCloudy-preview-thumbnailView')) &&
        props.supportsInsertLink;
    return (
        <div className={styles.container}>
            <div className={styles.buttonContainer}>
                {!isSplitButtonEnabled && (
                    <PrimaryButton
                        className={styles.button}
                        disabled={isSupportedActionsEmpty}
                        ariaLabel={loc(NextText)}
                        onClick={props.onNextClicked}>
                        {loc(NextText)}
                    </PrimaryButton>
                )}
                {isSplitButtonEnabled && !props.shouldHideInsertButton && (
                    <FilePickerShareLinkAttachButton
                        isDisabled={isSupportedActionsEmpty}
                        disabledAttachTooltip={props.disabledAttachTooltip}
                        onInsertClicked={props.onInsertClicked}
                        onAttachClicked={props.onAttachClicked}
                    />
                )}
                {isSplitButtonEnabled && props.shouldHideInsertButton && (
                    <DefaultButton
                        className={styles.button}
                        ariaLabel={loc(AttachText)}
                        onClick={props.onAttachClicked}>
                        {loc(AttachText)}
                    </DefaultButton>
                )}
                <span className={styles.cancelButtonContainer}>
                    <DefaultButton
                        className={styles.button}
                        ariaLabel={loc(CancelText)}
                        onClick={props.onCancelClicked}>
                        {loc(CancelText)}
                    </DefaultButton>
                </span>
            </div>
        </div>
    );
});
export default FilePickerPaneBottomPart;
